import { View, ViewProps } from "react-native";
import React, { Children } from "react";
import { useFetchTenantBrandingQuery } from "queries/tenant.queries";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import "./Stepper.css";

interface Context {
  activeIndex: number;
  setActiveIndex: React.Dispatch<React.SetStateAction<number>>;
}

interface Step {
  name: string;
  icon?: JSX.Element;
}
interface StepperProps extends ViewProps {
  step: number;
  steps: Step[];
}

const Stepper = (props: StepperProps) => {
  const { step, steps, children, ...restProps } = props;
  const arrayChildren = Children.toArray(children as React.ReactElement[]);
  const { data: branding } = useFetchTenantBrandingQuery();

  const primaryColor = branding?.primaryColor;
  const secondaryColor = branding?.secondaryColor;

  return (
    <View {...restProps} className="w-full">
      <ol className="c-stepper">
        {steps.map((StepperStep, index) => {
          const isComplete = step > index + 1;
          const isActive = step === index + 1;
          const isLast = index === steps.length - 1;
          return (
            <li className="c-stepper__item" key={index}>
              <div
                className="c-stepper__icon-wrapper"
                style={{
                  backgroundColor:
                    isComplete || isActive ? primaryColor : secondaryColor,
                }}
              >
                {isComplete ? (
                  <MaterialCommunityIcons
                    name="check"
                    size={16}
                    color="white"
                  ></MaterialCommunityIcons>
                ) : (
                  <>{StepperStep.icon}</>
                )}
              </div>
              <span className="c-stepper__title">{StepperStep.name}</span>
            </li>
          );
        })}
      </ol>
      <View>
        {Children.map(arrayChildren, (child, index) => (
          <View
            key={index}
            className={`${index + 1 === step ? "block" : "hidden"}`}
          >
            {/* @ts-ignore */}
            {child.props.children}
          </View>
        ))}
      </View>
    </View>
  );
};

const StepperContent = (props: ViewProps) => {
  const { children, ...restProps } = props;
  return <View {...restProps}>{children}</View>;
};

export { StepperContent };
export default Stepper;
